import { TLocationFilter } from '../address.interfaces';

export class LocationFilterModel implements TLocationFilter {
  constructor(public readonly region: string) {}
}
